import { gql } from '@apollo/client';

// Queries para notificações
export const GET_USER_NOTIFICATIONS = gql`
  query GetUserNotifications($limit: Int, $offset: Int) {
    userNotifications(limit: $limit, offset: $offset) {
      id
      userId
      accountId
      kind
      title
      message
      category
      read
      metadata
      createdAt
      updatedAt
      isRead
      isUnread
    }
  }
`;

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
  query GetUnreadNotificationsCount {
    unreadNotificationsCount
  }
`;